import { render, staticRenderFns } from "./Multiple.vue?vue&type=template&id=15cc31e6&"
import script from "./Multiple.vue?vue&type=script&lang=js&"
export * from "./Multiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports